import { useToast } from 'vue-toastification'

const toaster = useToast()

const options: object = {
  timeout: 3000,
  position: 'bottom-right',
  closeOnClick: false,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  icon: false,
}

class Toaster {
  static success(content: string) {
    toaster.success(content, options)
  }

  static error(content: string) {
    toaster.error(content, options)
  }
}

export default Toaster
